import { api } from 'new/api/axios';
import { createEndpoint } from 'new/api/utils';
import { TENANT } from 'new/tenants';
import { MyDentistResponse } from 'new/modules/PatientDetailsDashboard/types';
import {
  PatientFamilyMembershipsResponse,
  CancelSubscriptionRequest,
} from './types';

const { professionalName } = TENANT;

export const getMyDentist = createEndpoint({
  url: `/users/me/my-${professionalName}`,
  endpoint: ({ url }) => api.get<MyDentistResponse>(url),
});

export const getPatientFamilyMemberships = createEndpoint({
  url: '/patient/family-memberships',
  endpoint: ({ url }) => api.get<PatientFamilyMembershipsResponse>(url),
});

export const toggleSubscriptionAutoRenew = createEndpoint({
  url: '/subscriptions/patient/toggle-auto-renew/:id',
  endpoint: ({ url }) => api.post(url),
});

export const cancelSubscription = createEndpoint<
  unknown,
  CancelSubscriptionRequest
>({
  url: '/subscriptions/patient/cancel/:id',
  endpoint: ({ url, params }) => api.post(url, params),
});
